<script>
import Carregando from '~componentes/Carregando.vue';
import pessoaFisicaServico from '../servico';


export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      assinaturas: [],
      assinaturasFinalizadas: [],
      assinaturasDisponiveis: []
    }
  },
  mounted() {
    this.$root.tituloDaPagina = 'Assinatura Eletrônica';

    this.carregar();
  },
  methods: {
    carregar() {
      this.buscarAssinaturas()
      return;
    },
    buscarAssinaturas() {
      this.carregando = true;

      return pessoaFisicaServico
        .buscarAssinaturas()
        .then(dados => {
          this.assinaturas = dados;
        })
        .then(() => {
          this.carregando = false;
        });
    },
    filtrarAssinaturas() {
      if (this.ehGestao) {
        this.assinaturasDisponiveis = this.assinaturas.filter((assinatura) => {
          return !assinatura.documentoAssinatura || assinatura.documentoAssinatura.statusDocumento !== "CONCLUIDO"
        })
        this.assinaturasFinalizadas = this.assinaturas.filter((assinatura) => {
          return assinatura.documentoAssinatura && assinatura.documentoAssinatura.statusDocumento === "CONCLUIDO"
        })
        return;
      }

      this.assinaturasDisponiveis = this.assinaturas.filter((assinatura) => {
        return assinatura.statusAssinatura == "AGUARDANDO"
      })
      this.assinaturasFinalizadas = this.assinaturas.filter((assinatura) => {
        return assinatura.statusAssinatura !== "AGUARDANDO"
      })
    },
    podeAssinar(item) {
      if (!this.ehGestao) {
        return true;
      }

      return item.podeAssinarGestao === true;
    },
    downloadArquivoAssinatura(documento, assinatura) {
      return pessoaFisicaServico.downloadArquivoAssinatura(assinatura.idDocumentoAssinaturaAssinante, documento.nomeArquivo).then(
        arquivo => { arquivo.download() }
      )
    },
    assinarDocumento(documento) {
      this.$router.push({
        name: `${this.prefixoRota}.assinar`,
        params: { id: documento.idDocumentoAssinaturaAssinante },
      });
    },
    verDetalhesDocumento(documento) {
      this.$router.push({
        name: `${this.prefixoRota}.detalhes`,
        params: { id: documento.idDocumentoAssinaturaAssinante },
      });
    },
  },
  computed: {
    prefixoRota() {
      return (this.$route.meta && this.$route.meta.prefixoRotaAssinatura) || 'pessoa-fisica.assinatura';
    },
    ehGestao() {
      return this.prefixoRota === 'assinatura-embed';
    }
  },
  watch: {
    assinaturas() {
      this.filtrarAssinaturas()
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab" href="#tab-em-aberto">
              Em aberto
            </a>
          </li>
          <li>
            <a data-toggle="tab" href="#tab-finalizadas">
              Finalizadas
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-em-aberto" class="tab-pane active">
            <div class="panel-body">
              <h1>Em aberto</h1>

              <div class="table-responsive" style="padding-top: 20px;">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Nome do Arquivo</th>
                      <th>Tipo do Arquivo</th>
                      <th v-if="!ehGestao">Papel do Assinante</th>
                      <th>Data de Criação do Documento</th>
                      <th>{{ ehGestao ? 'Status do Documento' : 'Status da Assinatura' }}</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assinaturasDisponiveis" :key="item.idDocumentoAssinaturaAssinante">
                      <td>{{ item.documentoAssinatura.nomeArquivo }}</td>
                      <td>{{ item.documentoAssinatura.tipoDocumento }}</td>
                      <td v-if="!ehGestao">{{ item.papelAssinatura }}</td>
                      <td>{{ item.documentoAssinatura.dataHoraCriacao | formatarData }} - {{
                        item.documentoAssinatura.dataHoraCriacao | formatarHora }}</td>
                      <td>{{ ehGestao ? item.documentoAssinatura.statusDocumento : item.statusAssinatura }}</td>
                      <td class="text-center">
                        <button type="button" class="btn btn-success btn-xs" v-tooltip="'Baixar arquivo'"
                                @click="downloadArquivoAssinatura(item.documentoAssinatura, item)">
                          <i class="fa fa-download"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-xs" v-tooltip="'Ver detalhes'"
                                @click="verDetalhesDocumento(item)">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-if="podeAssinar(item)" type="button" class="btn btn-info btn-xs" v-tooltip="'Assinar documento'"
                                @click="assinarDocumento(item)">
                          <i class="fa fa-pencil"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="assinaturasDisponiveis.length === 0">
                      <td :colspan="ehGestao ? 5 : 6" class="text-center">Nenhum documento disponível para assinatura.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div id="tab-finalizadas" class="tab-pane">
            <div class="panel-body">
              <h1>Finalizadas</h1>
              <div class="table-responsive" style="padding-top: 20px;">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Nome do Arquivo</th>
                      <th>Tipo do Arquivo</th>
                      <th v-if="!ehGestao">Papel do Assinante</th>
                      <th>Data de Criação do Documento</th>
                      <th>{{ ehGestao ? 'Status do Documento' : 'Status da Assinatura' }}</th>
                      <th>Data da Assinatura</th>
                      <th class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in assinaturasFinalizadas"
                      :key="item.idDocumentoAssinaturaAssinante">
                      <td>{{ item.documentoAssinatura.nomeArquivo }}</td>
                      <td>{{ item.documentoAssinatura.tipoDocumento }}</td>
                      <td v-if="!ehGestao">{{ item.papelAssinatura }}</td>
                      <td>{{ item.documentoAssinatura.dataHoraCriacao | formatarData }} - {{
                        item.documentoAssinatura.dataHoraCriacao | formatarHora }}</td>
                      <td>{{ ehGestao ? item.documentoAssinatura.statusDocumento : item.statusAssinatura }}</td>
                      <td>{{ item.dataHoraAssinatura | formatarData }} - {{
                        item.dataHoraAssinatura | formatarHora }}</td>
                      <td class="text-center">
                        <button type="button" class="btn btn-success btn-xs" v-tooltip="'Baixar arquivo'"
                          @click="downloadArquivoAssinatura(item.documentoAssinatura, item)">
                          <i class="fa fa-download"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-xs" v-tooltip="'Ver detalhes'"
                          @click="verDetalhesDocumento(item)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="assinaturasFinalizadas.length === 0">
                      <td :colspan="ehGestao ? 6 : 7" class="text-center">Nenhum documento finalizado foi encontrado.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/Assinatura.vue